module.exports = __webpack_public_path__ + "img/1.99df0d35.jpg";